import type { ReactElement } from 'react';

import type { OfficeHostId } from './constants';

export function HostCanvas({ hostId }: { hostId: OfficeHostId }): ReactElement {
  if (hostId === 'excel') {
    return (
      <div className="bg-card w-full max-w-[300px] overflow-hidden rounded-sm border border-[var(--border)] shadow-sm">
        <div className="text-muted-foreground grid grid-cols-[28px_repeat(3,1fr)] border-b border-[var(--border)] font-mono text-[9px]">
          <span />
          {['A', 'B', 'C'].map((column) => (
            <span key={column} className="px-1.5 py-1 text-center">
              {column}
            </span>
          ))}
        </div>
        {[
          ['1', 'Region', 'Q3', 'Q4'],
          ['2', 'West', '1.24M', '1.41M'],
          ['3', 'East', '980K', '1.08M'],
          ['4', 'EMEA', '760K', '812K'],
        ].map((row, rowIndex) => (
          <div
            key={row[0]}
            className="grid grid-cols-[28px_repeat(3,1fr)] border-b border-[var(--border)] last:border-b-0"
          >
            <span className="text-muted-foreground bg-muted/80 px-1 py-1.5 text-center font-mono text-[9px]">
              {row[0]}
            </span>
            {row.slice(1).map((cell, cellIndex) => (
              <span
                key={`${row[0]}-${cell}`}
                className={`truncate px-1.5 py-1.5 text-[10px] ${
                  rowIndex === 0
                    ? 'bg-[#207245]/10 font-semibold text-[#207245]'
                    : cellIndex === 0
                      ? 'text-foreground'
                      : 'text-muted-foreground font-mono'
                }`}
              >
                {cell}
              </span>
            ))}
          </div>
        ))}
      </div>
    );
  }

  if (hostId === 'powerpoint') {
    return (
      <div className="bg-muted flex w-full max-w-[300px] overflow-hidden rounded-sm border border-[var(--border)] shadow-sm">
        <div className="border-border flex w-11 shrink-0 flex-col gap-1.5 border-r bg-[var(--card)] p-1.5">
          {['01', '02', '03'].map((slide, index) => (
            <div
              key={slide}
              className={`aspect-[16/10] rounded-[2px] border ${
                index === 0 ? 'border-[#d24625] bg-[#d24625]/10' : 'border-border bg-muted'
              }`}
            >
              <div className="bg-foreground/15 mx-1 mt-1.5 h-0.5 w-3/5" />
              <div className="bg-foreground/10 mx-1 mt-0.5 h-0.5 w-2/5" />
            </div>
          ))}
        </div>
        <div className="bg-card relative min-h-[148px] flex-1 p-3.5">
          <div className="absolute inset-y-0 left-0 w-1 bg-[#d24625]" />
          <p className="text-[9px] font-semibold tracking-[0.16em] text-[#d24625] uppercase">
            Q3 review
          </p>
          <p className="text-foreground mt-1.5 text-[13px] leading-tight font-semibold">
            Board security brief
          </p>
          <ul className="mt-3 space-y-1.5">
            {['Vault access log', 'Share policy update', 'Key rotation'].map((item) => (
              <li key={item} className="flex items-center gap-1.5">
                <span className="size-1 shrink-0 rounded-full bg-[#d24625]" />
                <span className="text-muted-foreground text-[10px]">{item}</span>
              </li>
            ))}
          </ul>
          <p className="text-muted-foreground mt-4 font-mono text-[8px]">Slide 1 of 3</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card w-full max-w-[300px] rounded-sm border border-[var(--border)] px-6 py-6 shadow-sm">
      <p className="text-muted-foreground font-mono text-[9px] tracking-[0.16em] uppercase">
        Confidential
      </p>
      <p className="text-foreground mt-2 text-sm font-semibold tracking-tight">Mutual NDA — Acme</p>
      <div className="mt-4 space-y-2">
        <div className="bg-foreground/20 h-1.5 w-full rounded-full" />
        <div className="bg-foreground/12 h-1.5 w-11/12 rounded-full" />
        <div className="bg-foreground/12 h-1.5 w-10/12 rounded-full" />
        <div className="bg-foreground/12 h-1.5 w-full rounded-full" />
        <div className="bg-foreground/12 h-1.5 w-4/5 rounded-full" />
      </div>
      <div className="border-border mt-6 flex items-end justify-between border-t pt-3">
        <div>
          <p className="text-muted-foreground text-[9px]">Signed</p>
          <p className="text-foreground text-[11px] italic">A. Chen</p>
        </div>
        <div className="bg-foreground/25 h-px w-16" />
      </div>
    </div>
  );
}
